<template>
    <div>
        <gallery :images="images" :index="index" @close="index = null"></gallery>
        <div
            class="image"
            v-for="(image, imageIndex) in images"
            :key="imageIndex"
            @click="index = imageIndex"
            :style="{ backgroundImage: 'url(' + image.href + ')', width: 100 / pics_in_row + '%', paddingTop: 100 / pics_in_row + '%'}"
        ></div>
    </div>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
    props: {
        images: Array,
        imageNames: Array,
        pics_in_row: Number
    },
    data: function() {
        return {
            index: null
        };
    },

    components: {
        gallery: VueGallery
    },

    mounted() {
    }
};
</script> 


<style lang="scss" scoped>
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    float: left;
    display: table-row;
    border: 1px solid #fff;
    cursor: pointer;
    width: 20%;
    padding-top: 20%;
    position: relative;

    .title {
        font-size: 14px;
        display: none;
        background: #f6f4f5;
        color: #999998;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        padding: 1rem;
    }

    &:hover {
        .title {
            display: block;
        }
    }
}

@media screen and (max-width: 767px) {
    .image {
        width: 50% !important;
        padding-top: 50% !important;
    }
}

@media screen and (max-width: 480px) {
    .image {
        width: 100% !important;
        padding-top: 100% !important;
    }
}

.blueimp-gallery > .next,
.blueimp-gallery > .prev {
    color: #fff !important;
}
</style> 